import React, { Fragment, FC } from 'react';

import { Box } from '@adsk/alloy-react-box';

import { Collection, License } from '../helpers/types';

type AutomaticAboutBoxContentProps = {
  collections: Collection[];
};

const AutomaticAboutBoxContent: FC<AutomaticAboutBoxContentProps> = ({
  collections,
}) => {
  return (
    <>
      {collections?.map((collection: Collection) => (
        <Fragment key={collection.type}>
          <Box margin="10px 0 4px" typography="heading4" marginTop="20px">
            The following components are licensed under {collection.type}{' '}
            license:
          </Box>
          {collection.licenses.map((license: License, i) => {
            let author;

            if (typeof license.author === 'string') {
              author = license.author;
            } else if (typeof license.author === 'object') {
              author = license.author.name;
            } else {
              author = license.repository;
            }

            return (
              <div key={license.name + i}>
                <Box margin="10px 0 4px" typography="labelMedium">
                  {license.name}
                </Box>
                <Box margin="10px 0 4px" typography="labelSmall" marginTop={0}>
                  Copyright {author}
                </Box>
                {!collection.attribution && (
                  <Box margin="10px 0 4px">{license.licenseText}</Box>
                )}
              </div>
            );
          })}
          {collection.attribution && (
            <Box margin="10px 0 4px">{collection.attribution}</Box>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default AutomaticAboutBoxContent;
